export default "__VITE_ASSET__vPVFqvDv__"